import { observer } from 'mobx-react-lite'
import { CardString, Suit, Value } from 'pokersolver'
import { FC } from 'react'
import { Platform, StyleProp, StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native'
import { SvgProps } from 'react-native-svg'

import { color, fontFamily } from '../../../theme'
import ClubIcon from './assets/club.svg'
import DiamondIcon from './assets/diamond.svg'
import HeartIcon from './assets/heart.svg'
import SpadeIcon from './assets/spade.svg'

type DegreeString = `${string}deg`
export interface CardProps {
  card?: CardString
  fontSize: number
  horizontal?: boolean
  rotateDegrees?: DegreeString
  disabled?: boolean
  cardStyle?: StyleProp<ViewStyle> | StyleProp<ViewStyle>[]
  cardTextStyle?: StyleProp<TextStyle>
}

const Icons: Record<Suit, FC<SvgProps>> = {
  c: ClubIcon,
  d: DiamondIcon,
  h: HeartIcon,
  s: SpadeIcon
}

const primaryAxisModificator = 3
const secondaryAxisModificator = 2

export const Card = observer(
  ({ card, fontSize, horizontal, rotateDegrees, disabled = false, cardStyle, cardTextStyle }: CardProps) => {
    const axisStyles: StyleProp<ViewStyle> = {
      flexDirection: horizontal ? 'row' : 'column',
      height: fontSize * (horizontal ? secondaryAxisModificator : primaryAxisModificator),
      width: fontSize * (horizontal ? primaryAxisModificator : secondaryAxisModificator),
      transform: rotateDegrees ? [{ rotate: rotateDegrees }] : [],
      opacity: disabled ? 0.3 : 1
    }

    if (!card) return <View style={[styles.container, styles.emptyContainer, axisStyles]} />

    const [value, suit] = card as unknown as [Value, Suit]

    const Svg = Icons[suit]

    return (
      <View style={[styles.container, axisStyles, cardStyle]}>
        <Text style={[{ fontSize }, cardTextStyle]}>{value.replace('T', '10')}</Text>
        <Svg
          height="40%"
          width="40%"
          preserveAspectRatio="xMidYMid meet"
          style={Platform.OS === 'web' ? {} : { flex: 0 }}
        />
      </View>
    )
  }
)

const styles = StyleSheet.create({
  container: {
    borderColor: '#121212',
    borderWidth: 1,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 32,
    width: 48,
    paddingTop: 3
  },
  emptyContainer: {
    borderColor: color.palette.lightGrey,
    backgroundColor: color.palette.cream
  },
  horizontal: {
    flexDirection: 'row'
  },
  text: {
    fontFamily: fontFamily.FeatureDeckMedium,
    textAlignVertical: 'center' // TODO: text is not fully centered with icon.
  }
})
